import * as styles from "./ParagraphChecklist.module.scss";

import { graphql } from "gatsby";
import React from "react";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface ParagraphChecklistProps {
	heading: string;
	jumpLinksTitle?: string;
	htmlText: string;
	listType: string;
	image: DogsTrust.MediaImageProps;
}

export const getParagraphChecklistProps = ({
	field_heading,
	field_jump_links_title,
	field_text,
	field_list_type,
	relationships: { field_image },
}: Queries.ParagraphChecklistDataFragment): ParagraphChecklistProps => ({
	heading: field_heading,
	jumpLinksTitle: field_jump_links_title,
	listType: field_list_type,
	htmlText: field_text?.value,
	image: field_image[0]
		? {
				src: field_image[0].field_media_image?.uri,
				alt: field_image[0].field_media_image?.alt,
			}
		: undefined,
});
export const ParagraphChecklist: React.FC<ParagraphChecklistProps> = ({
	heading,
	jumpLinksTitle,
	htmlText,
	listType,
	image,
}) => {
	return (
		<WrappedSection
			sectionName="ParagraphChecklist"
			sectionColour={
				listType === "bulletlist" ? Colours.OATMEAL : Colours.SANDY_FUR
			}
			sectionBottomImage={image}
		>
			<div className={styles.contentarea}>
				{heading && (
					<div className={styles.title}>
						{jumpLinksTitle ? (
							<h2 data-jumplinkstitle={jumpLinksTitle}>{heading}</h2>
						) : (
							<h2>{heading}</h2>
						)}
					</div>
				)}
				<div
					className={
						listType === "bulletlist" ? styles.bulletlist : styles.checklist
					}
					// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
					dangerouslySetInnerHTML={{
						__html: htmlText,
					}}
				/>
			</div>
		</WrappedSection>
	);
};

export default ParagraphChecklist;

export const fragment = graphql`
    fragment ParagraphChecklistData on paragraph__checklist {
        __typename
        id
        field_heading
		field_jump_links_title
        field_text {
            value
        }
        field_list_type
        relationships {
            field_image {
                field_media_image {
                    alt
                    uri
                }
            }
        }
    }
`;
